/**
 * Auth API methods.
 */
import api from "./client";

export interface User {
  id: string;
  email: string;
  name: string | null;
  phone: string | null;
  suite_number: string | null;
  is_admin: boolean;
  is_active: boolean;
  has_active_plan: boolean;
  plan_tier: string | null;
  billing_cycle: string | null;
  plan_started_at: string | null;
  plan_renews_at: string | null;
  created_at: string;
}

export interface AuthResponse {
  access_token: string;
  token_type: string;
  user: User;
}

export const authApi = {
  register: (data: { name: string; email: string; password: string; phone?: string }) =>
    api.post<AuthResponse>("/auth/register", data).then((r) => r.data),

  login: (data: { email: string; password: string }) =>
    api.post<AuthResponse>("/auth/login", data).then((r) => r.data),

  getMe: () => api.get<User>("/auth/me").then((r) => r.data),

  updateProfile: (data: { name?: string; phone?: string }) =>
    api.patch<User>("/auth/me", data).then((r) => r.data),

  getMyAddress: () =>
    api.get<{
      name: string;
      suite: string | null;
      street: string | null;
      city: string;
      state: string;
      zip: string | null;
      country: string;
      full: string | null;
      masked: boolean;
      message?: string;
    }>("/auth/me/address").then((r) => r.data),

  getMyUsageStats: () =>
    api.get<{
      total_packages: number;
      packages_in_warehouse: number;
      packages_shipped: number;
      total_weight_lbs: number;
      total_shipments: number;
      pending_shipments: number;
      total_invoice_amount_usd: number;
      outstanding_invoice_amount_usd: number;
      last_shipment_date: string | null;
      last_package_date: string | null;
    }>("/auth/me/usage-stats").then((r) => r.data),

  updatePlan: (data: { plan_tier: string; billing_cycle: string }) =>
    api.patch<User>("/auth/me/plan", data).then((r) => r.data),
};